module.exports = __webpack_public_path__ + "img/Icon_Search.1547a786.svg";